export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb2e4730d8b8f74de3a8c8e37e4b37d54fb2904a7&name=fetchTypeahead!'